module.exports = __webpack_public_path__ + "static/media/holdSpacebar.8ca25c15.png";